document.documentElement.classList.add('teka-js');
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-teka-menu]');
  if (!trigger) return;
  const open = document.body.classList.toggle('teka-menu-open');
  trigger.setAttribute('aria-expanded', String(open));
});

document.querySelectorAll('[data-teka-product-form]').forEach((form) => {
  const price = document.querySelector('[data-teka-product-price]');
  const button = form.querySelector('button[type="submit"]');
  form.addEventListener('change', (event) => {
    const option = event.target.closest('input[name="id"]');
    if (!option) return;
    if (price) price.textContent = option.dataset.price || price.textContent;
    if (button && option.dataset.price) button.textContent = `Add to bag — ${option.dataset.price}`;
  });
});

// Reordering the archive should not need a second click. The form still posts
// on its own when JavaScript is unavailable, which is why the button exists.
document.querySelectorAll('[data-teka-sort] select').forEach((select) => {
  select.addEventListener('change', () => { select.form?.submit(); });
});

document.querySelectorAll('[data-teka-quick-add]').forEach((form) => {
  form.addEventListener('submit', async (event) => {
    if (!globalThis.fetch || !globalThis.FormData) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    const status = form.querySelector('.teka-card__quick-status');
    const original = button?.textContent || 'Add to bag';
    if (button) { button.disabled = true; button.textContent = 'Adding…'; }
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST', headers: {'Accept': 'application/json'}, body: new FormData(form)
      });
      if (!response.ok) throw new Error('Could not add this size');
      const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((item) => item.json());
      document.querySelectorAll('.teka-bag-link span').forEach((node) => { node.textContent = String(cart.item_count); });
      if (status) status.textContent = 'Added to your bag.';
      if (button) button.textContent = 'Added ✓';
      window.setTimeout(() => { if (button) button.textContent = original; }, 1800);
    } catch (error) {
      if (status) status.textContent = error.message || 'Please try again.';
      if (button) button.textContent = original;
    } finally {
      if (button) button.disabled = false;
    }
  });
});

(() => {
  const root = document.body;
  const endpoint = (root.dataset.tekaInsight || '').replace(/\/$/, '');
  const productId = root.dataset.tekaProductId || '';
  const productHandle = root.dataset.tekaProductHandle || '';
  if (!endpoint || !productId) return;

  const send = (name) => {
    const eventId = globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random()}`;
    const payload = JSON.stringify({
      event_id: eventId,
      event: name,
      product_id: productId,
      product_handle: productHandle
    });
    if (!navigator.sendBeacon?.(`${endpoint}/v1/event`, new Blob([payload], {type: 'application/json'}))) {
      fetch(`${endpoint}/v1/event`, {method: 'POST', headers: {'Content-Type': 'application/json'}, body: payload, keepalive: true});
    }
  };

  const viewKey = `teka-view-${productId}`;
  if (!sessionStorage.getItem(viewKey)) {
    sessionStorage.setItem(viewKey, '1');
    send('product_viewed');
  }
  document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', () => send('product_added_to_cart'));
  });
})();
